const getAppEnv = () => localStorage.getItem('app_env')

export const appInService = () => ['production', 'dev', 'mde', 'staging'].includes(getAppEnv())

export const appInProduction = () => getAppEnv() === 'production'

export const appInDevelopment = () => ['dev', 'mde'].includes(getAppEnv())

export const appInStaging = () => getAppEnv() === 'staging'

export const appInMDE = () => getAppEnv() === 'mde'

export const appInTesting = () => getAppEnv() === 'testing'

export const appInLocal = () => getAppEnv() === 'local'

export const appInLocalOrDevelopment = () => appInLocal() || appInDevelopment()

export const appInStagingOrProduction = () => appInStaging() || appInProduction()
